/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputUavMissionTrackAction } from './OutputUavMissionTrackAction';
import {
    OutputUavMissionTrackActionFromJSON,
    OutputUavMissionTrackActionFromJSONTyped,
    OutputUavMissionTrackActionToJSON,
} from './OutputUavMissionTrackAction';
import type { OutputUavMissionTrackRevision } from './OutputUavMissionTrackRevision';
import {
    OutputUavMissionTrackRevisionFromJSON,
    OutputUavMissionTrackRevisionFromJSONTyped,
    OutputUavMissionTrackRevisionToJSON,
} from './OutputUavMissionTrackRevision';

/**
 * 
 * @export
 * @interface OutputUavMissionTrack
 */
export interface OutputUavMissionTrack {
    /**
     * Actions — журнал дій над заявкою хронологічно: зміни фаз, уточнення позиції/параметрів,
     * збиття, правки. Точки на мапі — дії з позицією (lat/lng).
     * @type {Array<OutputUavMissionTrackAction>}
     * @memberof OutputUavMissionTrack
     */
    actions?: Array<OutputUavMissionTrackAction>;
    /**
     * Revisions — хронологічно; остання — маршрут, з яким виліт завершився, попередні — ті, що
     * правили посеред польоту. Порожньо — у заявки немає маршруту.
     * @type {Array<OutputUavMissionTrackRevision>}
     * @memberof OutputUavMissionTrack
     */
    revisions?: Array<OutputUavMissionTrackRevision>;
}

/**
 * Check if a given object implements the OutputUavMissionTrack interface.
 */
export function instanceOfOutputUavMissionTrack(value: object): boolean {
    return true;
}

export function OutputUavMissionTrackFromJSON(json: any): OutputUavMissionTrack {
    return OutputUavMissionTrackFromJSONTyped(json, false);
}

export function OutputUavMissionTrackFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputUavMissionTrack {
    if (json == null) {
        return json;
    }
    return {
        
        'actions': json['actions'] == null ? undefined : ((json['actions'] as Array<any>).map(OutputUavMissionTrackActionFromJSON)),
        'revisions': json['revisions'] == null ? undefined : ((json['revisions'] as Array<any>).map(OutputUavMissionTrackRevisionFromJSON)),
    };
}

export function OutputUavMissionTrackToJSON(value?: OutputUavMissionTrack | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'actions': value['actions'] == null ? undefined : ((value['actions'] as Array<any>).map(OutputUavMissionTrackActionToJSON)),
        'revisions': value['revisions'] == null ? undefined : ((value['revisions'] as Array<any>).map(OutputUavMissionTrackRevisionToJSON)),
    };
}

